import React,{ useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"

import { Box } from '@mui/system'
import { Divider } from '@mui/material'
import AlertDialog from './components/AlertDialog';
import logo from 'assets/images/sectorLogos/dashboardlogo.svg'
import { ArrowRightBracketIcon, ChartIcon, MemoIcon, MessageIcon, PresentationScreenIcon, ResturantIcon, SettingIcon, UserIcon, WalletIcon } from 'Sui_Icons'
import { MenuItem } from './components/MenuItem'
import { Link } from "react-router-dom";
import { SuiBox } from 'components'

import { logout } from 'redux/actions/auth';

export const SidebarUser = ({ useInMobile }) => {

    const [ openAlert, setOpenAlert ] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const items = [
        { title: 'داشبورد', icon: ChartIcon, route: '' },
        {
            title: 'آموزش تعاملی', icon: PresentationScreenIcon, route: '/intractivelearning', innnerSection: [
                { title: 'لیست آموزش های من', route: 'intractivelearning/list' },
            ]
        },
        {
            title: 'آزمون ها', icon: MemoIcon, route: '/quiz', innnerSection: [
                { title: ' آزمون های من', route: 'quiz/list' },
            ]
        },
        {
            title: 'امور مالی', icon: WalletIcon, route: '/finance', innnerSection: [
                { title: 'کیف پول', route: 'finance/wallet' },
                { title: 'مدیریت مالی', route: 'finance/management' },
            ]
        },
        { title: 'اطلاعات کاربری', icon: UserIcon, route: 'profile' },
        {
            title: 'پشیبانی', icon: MessageIcon, route: '/support', innnerSection: [
                { title: 'تیکت ها', route: 'support/tickets' },
            ]
        },
        { title: 'بلاگ', icon: ResturantIcon, route: 'blog' },
    ]

    const buttonItems = [
        // { title: 'تنطیمات', icon: SettingIcon, route: 'setting' },
         { title: 'خروج از حساب', icon: ArrowRightBracketIcon, route: '', onClickCallback: () => { preLogoutHandler() } },
    ]

    const preLogoutHandler = () => {
        setOpenAlert(true);
    };

    const handleSetOpen = ()=>{
        setOpenAlert(false);
        navigate("/dashboard")
    }

    const logoutHandler = useCallback(() => {
        dispatch(logout());
        navigate("/")
    }, [dispatch]);

    return (
        <Box sx={{ display: useInMobile ? { xs: 'flex', lg: 'none' } : { xs: 'none', lg: 'flex' }, flexDirection: 'column', py: 1, width: '275px', alignItems: 'start', justifyContent: 'space-between', backgroundColor: '#fff', height: '100vh', overflow: 'auto', boxSizing: 'border-box' }}>

            <Box sx={{ borderBottom: '1px solid #F1F1F9', width: '100%', py: 2.25, pl: 0.5, boxSizing: 'border-box', display: { xs: 'none', lg: 'flex' }, justifyContent: 'center' }}>
            <SuiBox component={Link} to="/" display={{ xs: 'none', md: 'block' }}> <img src={logo} /></SuiBox>
                {/* <Divider sx={{ m: 0 }} /> */}
            </Box>

            <Box sx={{ my: 0.5, pl: 0.5, px: 2, boxSizing: 'border-box' }}>
                {items.map(item => {
                    return <MenuItem {...item} />
                })}
            </Box>

            <Box sx={{ borderTop: '1px solid #e2e2e2', width: '100%', py: 0.5, px: 2, boxSizing: 'border-box' }}>
                <Box sx={{ borderRadius: 1, background: '#F1F9FE', display: 'flex', alignItems: 'center', my: 0.5 }}>
                    {buttonItems.map(item => {
                        return <MenuItem  my={1.5} {...item} />
                    })}
                    {/* <MenuItem my={1} {...{ title: 'خروج از حساب', icon: ArrowRightBracketIcon, onClickCallback: () => { preLogoutHandler() } }} /> */}
                </Box>
            </Box>
            <AlertDialog discription={'برای خروج از حساب کاربری مطمین هستید؟'} open={openAlert} handleSetOpen={handleSetOpen} logoutHandler={logoutHandler} />
        </Box>
    )
}
